import { useEffect, useState } from 'react'
import api, { IWorkplaceGroupTableRecord } from '@api'

interface State {
  items: IWorkplaceGroupTableRecord[]
}

export interface UseWorkplaceGroupsCatalogHook extends State {
  isFetching: boolean
  reload: () => void
}

export default function useWorkplaceGroupsCatalog(): UseWorkplaceGroupsCatalogHook {
  const [shouldReload, setShouldReload] = useState(false)
  const [isFetching, setFetching] = useState(true)
  const [items, setItems] = useState<IWorkplaceGroupTableRecord[]>([])

  useEffect(() => {
    setShouldReload(false)

    if (!items.length) {
      setFetching(true)
    }

    api.workplaceGroup.catalog().then((items) => {
      setFetching(false)
      setItems(items)
    })
    //eslint-disable-next-line
  }, [shouldReload])

  return {
    items,
    isFetching,
    reload: () => {
      setShouldReload(true)
    },
  }
}
